import { AdaptedGroup } from "../models";
import { getTotal, getUsed, getWaiting } from "./groupCapacityStats";

export interface GetDonutRowsProps {
  total: number;
  used: number;
  waiting: number;
}

export const getDonutRows = ({ total, waiting, used }: GetDonutRowsProps) => {
  const free = total - used >= 0 ? total - used : 0;
  const freePercentage = free / total >= 0 ? Math.floor((free / total) * 100) : 100;
  const usedPercentage = used / total >= 0 ? Math.ceil((used / total) * 100) : 0;
  const waitingPercetage = waiting / total >= 0 ? Math.floor((waiting / total) * 100) : 0;

  return [
    {
      name: "Libre",
      percentage: freePercentage,
      value: free,
    },
    {
      name: "Usado",
      percentage: usedPercentage,
      value: used,
    },
    {
      name: "En espera",
      percentage: waitingPercetage,
      value: waiting,
    },
  ];
};

export interface DonutRow {
  name: string;
  percentage: number;
  value: number;
}

const donut = (group: Partial<AdaptedGroup>) => {
  const total = getTotal(group) ?? 0;
  const waiting = getWaiting(group) ?? 0;
  const used = getUsed(group) ?? 0;

  return getDonutRows({
    total,
    waiting,
    used,
  });
};

export default donut;
